var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTractorBeam2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 103,
    viewBox: "0 0 107 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M53.4229 34.152C62.8537 34.152 70.4989 26.5068 70.4989 17.076C70.4989 7.64519 62.8537 0 53.4229 0C43.9921 0 36.3469 7.64519 36.3469 17.076C36.3469 26.5068 43.9921 34.152 53.4229 34.152Z",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4228 32.614C62.0042 32.614 68.9608 25.6574 68.9608 17.076C68.9608 8.49456 62.0042 1.53796 53.4228 1.53796C44.8414 1.53796 37.8848 8.49456 37.8848 17.076C37.8848 25.6574 44.8414 32.614 53.4228 32.614Z",
    fill: "#00FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4229 30.122C60.6275 30.122 66.4679 24.2815 66.4679 17.077C66.4679 9.87243 60.6275 4.03198 53.4229 4.03198C46.2184 4.03198 40.3779 9.87243 40.3779 17.077C40.3779 24.2815 46.2184 30.122 53.4229 30.122Z",
    fill: "#C7FFFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2798 50.1581V74.8171",
    stroke: "#1B1B24",
    strokeWidth: 2.347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7329 43.1641H35.8259V56.0481C35.8259 56.3398 35.71 56.6196 35.5037 56.8259C35.2974 57.0322 35.0176 57.1481 34.7259 57.1481H31.8329C31.5412 57.1481 31.2614 57.0322 31.0551 56.8259C30.8488 56.6196 30.7329 56.3398 30.7329 56.0481V43.1641Z",
    fill: "url(#paint0_linear_1297_2294)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2739 80.2941H31.2849V70.4431C31.2849 70.1513 31.4008 69.8715 31.6071 69.6652C31.8134 69.459 32.0932 69.3431 32.3849 69.3431H34.1739C34.4657 69.3431 34.7455 69.459 34.9517 69.6652C35.158 69.8715 35.2739 70.1513 35.2739 70.4431V80.2941Z",
    fill: "url(#paint1_linear_1297_2294)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5659 50.1581V74.8171",
    stroke: "#1B1B24",
    strokeWidth: 2.347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.02 43.1641H76.113V56.0481C76.113 56.3398 75.9971 56.6196 75.7908 56.8259C75.5845 57.0322 75.3048 57.1481 75.013 57.1481H72.12C71.8283 57.1481 71.5485 57.0322 71.3422 56.8259C71.1359 56.6196 71.02 56.3398 71.02 56.0481V43.1641Z",
    fill: "url(#paint2_linear_1297_2294)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.561 80.2941H71.572V70.4431C71.572 70.1513 71.6879 69.8715 71.8942 69.6652C72.1005 69.459 72.3803 69.3431 72.672 69.3431H74.461C74.7528 69.3431 75.0326 69.459 75.2389 69.6652C75.4451 69.8715 75.561 70.1513 75.561 70.4431V80.2941Z",
    fill: "url(#paint3_linear_1297_2294)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.338 36.073H30.508C29.8072 36.073 29.239 36.6411 29.239 37.342V43.943C29.239 44.6438 29.8072 45.212 30.508 45.212H76.338C77.0389 45.212 77.607 44.6438 77.607 43.943V37.342C77.607 36.6411 77.0389 36.073 76.338 36.073Z",
    fill: "url(#paint4_linear_1297_2294)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8549 14.083H73.9919L78.6849 21.906H28.1609L32.8549 14.083Z",
    fill: "url(#paint5_linear_1297_2294)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.734 21.906L106.846 24.876C103.623 36.995 80.934 46.385 53.423 46.385C25.912 46.385 3.223 36.995 0 24.876L3.112 21.906H103.734Z",
    fill: "url(#paint6_radial_1297_2294)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1.913 24.876H104.933C105.699 24.876 106.121 24.184 105.633 23.722L104.003 22.166C103.811 21.9947 103.561 21.9019 103.303 21.906H3.54399C3.28631 21.9019 3.03653 21.9947 2.84404 22.166L1.21403 23.722C0.72303 24.184 1.147 24.876 1.913 24.876Z",
    fill: "url(#paint7_linear_1297_2294)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M106.846 24.876C103.623 36.995 80.934 46.3849 53.423 46.3849C25.912 46.3849 3.223 36.995 0 24.876H106.846Z",
    fill: "url(#paint8_linear_1297_2294)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.04297 25.0701C8.04297 25.0701 22.507 46.385 53.423 46.385",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.8029 25.0701C98.8029 25.0701 84.3389 46.385 53.4229 46.385",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.207 25.0701C26.207 25.0701 34.882 46.385 53.423 46.385",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.6389 25.0701C80.6389 25.0701 71.9639 46.385 53.4229 46.385",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.123 25.0701C42.123 25.0701 45.723 46.385 53.423 46.385",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M64.7228 25.0701C64.7228 25.0701 61.1229 46.385 53.4229 46.385",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.57495 31.1471H103.27",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.957 39.025H91.888",
    stroke: "#1B1B24",
    strokeWidth: 0.782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.952 53.168H41.894L37.894 49.168V47.957L40.3491 45.502H66.5031L68.958 47.957V49.168L64.952 53.168Z",
    fill: "url(#paint9_linear_1297_2294)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8911 47.953H68.9551L68.0611 45.499H38.7861L37.8911 47.953Z",
    fill: "url(#paint10_linear_1297_2294)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2369 57.1519V53.7699L64.7829 53.1699H42.0639L41.6089 53.7699V57.1519L43.9019 59.4449V62.5349L41.6089 63.5699V66.7449L42.2929 67.429H64.5529L65.2369 66.7449V63.5699L62.9439 62.5349V59.4449L65.2369 57.1519Z",
    fill: "url(#paint11_linear_1297_2294)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M41.6089 57.152H65.2359L62.9429 59.445H43.9029L41.6089 57.152Z",
    fill: "url(#paint12_linear_1297_2294)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.6089 63.5709L43.9019 62.5359H62.9419L65.2349 63.5709H41.6089Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4429 77.05C78.4429 83.6858 75.8068 90.0497 71.1147 94.7419C66.4225 99.434 60.0586 102.07 53.4229 102.07C46.7871 102.07 40.4232 99.434 35.731 94.7419C31.0389 90.0497 28.4028 83.6858 28.4028 77.05H78.4429Z",
    fill: "url(#paint13_linear_1297_2294)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4028 77.0499L42.2938 67.4299H64.5529L78.4438 77.0499H28.4028Z",
    fill: "url(#paint14_linear_1297_2294)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.239 82.99L28.864 81.866C29.6601 85.9121 31.4425 89.6993 34.053 92.8915C36.6635 96.0838 40.0215 98.5825 43.829 100.166V94.172C39.6313 91.6914 36.5538 87.6853 35.239 82.99Z",
    fill: "url(#paint15_linear_1297_2294)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6071 82.99L77.9821 81.866C77.186 85.9121 75.4036 89.6993 72.7932 92.8915C70.1827 96.0838 66.8247 98.5825 63.0171 100.166V94.172C67.2148 91.6914 70.2923 87.6853 71.6071 82.99Z",
    fill: "url(#paint16_linear_1297_2294)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6259 82.7639H51.2189C50.4899 82.7639 49.8989 83.3549 49.8989 84.0839V91.4469C49.8989 92.1759 50.4899 92.7669 51.2189 92.7669H55.6259C56.3549 92.7669 56.9459 92.1759 56.9459 91.4469V84.0839C56.9459 83.3549 56.3549 82.7639 55.6259 82.7639Z",
    fill: "url(#paint17_linear_1297_2294)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.433 86.4451H48.412C47.683 86.4451 47.092 87.0361 47.092 87.7651V87.7661C47.092 88.4951 47.683 89.0861 48.412 89.0861H58.433C59.1621 89.0861 59.753 88.4951 59.753 87.7661V87.7651C59.753 87.0361 59.1621 86.4451 58.433 86.4451Z",
    fill: "url(#paint18_linear_1297_2294)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.4229 90.894C55.151 90.894 56.5519 89.4931 56.5519 87.765C56.5519 86.0369 55.151 84.636 53.4229 84.636C51.6948 84.636 50.2939 86.0369 50.2939 87.765C50.2939 89.4931 51.6948 90.894 53.4229 90.894Z",
    fill: "#00FFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4228 90.244C54.792 90.244 55.9018 89.1341 55.9018 87.765C55.9018 86.3959 54.792 85.286 53.4228 85.286C52.0537 85.286 50.9438 86.3959 50.9438 87.765C50.9438 89.1341 52.0537 90.244 53.4228 90.244Z",
    fill: "#00FFFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.423 89.741C54.5138 89.741 55.398 88.8568 55.398 87.766C55.398 86.6753 54.5138 85.791 53.423 85.791C52.3322 85.791 51.448 86.6753 51.448 87.766C51.448 88.8568 52.3322 89.741 53.423 89.741Z",
    fill: "#C7FFFD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4299 88.556C48.8668 88.556 49.2209 88.2019 49.2209 87.765C49.2209 87.3281 48.8668 86.974 48.4299 86.974C47.9931 86.974 47.6389 87.3281 47.6389 87.765C47.6389 88.2019 47.9931 88.556 48.4299 88.556Z",
    fill: "#4A4A5B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.415 88.556C58.8519 88.556 59.206 88.2019 59.206 87.765C59.206 87.3281 58.8519 86.974 58.415 86.974C57.9782 86.974 57.624 87.3281 57.624 87.765C57.624 88.2019 57.9782 88.556 58.415 88.556Z",
    fill: "#4A4A5B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.665 7.526H52.18C51.6084 7.526 51.145 7.98939 51.145 8.561V16.637C51.145 17.2086 51.6084 17.672 52.18 17.672H54.665C55.2366 17.672 55.7 17.2086 55.7 16.637V8.561C55.7 7.98939 55.2366 7.526 54.665 7.526Z",
    fill: "#101016"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1109 7.526H31.9029C31.3313 7.526 30.8679 7.98939 30.8679 8.561V16.637C30.8679 17.2086 31.3313 17.672 31.9029 17.672H32.1109C32.6825 17.672 33.1459 17.2086 33.1459 16.637V8.561C33.1459 7.98939 32.6825 7.526 32.1109 7.526Z",
    fill: "#101016"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9439 7.526H74.7359C74.1643 7.526 73.7009 7.98939 73.7009 8.561V16.637C73.7009 17.2086 74.1643 17.672 74.7359 17.672H74.9439C75.5155 17.672 75.9789 17.2086 75.9789 16.637V8.561C75.9789 7.98939 75.5155 7.526 74.9439 7.526Z",
    fill: "#101016"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1297_2294",
    x1: 30.6718,
    y1: 50.1561,
    x2: 35.8412,
    y2: 50.1561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1297_2294",
    x1: 35.8882,
    y1: 74.8186,
    x2: 30.7185,
    y2: 74.8186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1297_2294",
    x1: 70.9589,
    y1: 50.1561,
    x2: 76.1283,
    y2: 50.1561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1297_2294",
    x1: 76.1753,
    y1: 74.8186,
    x2: 71.0056,
    y2: 74.8186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1297_2294",
    x1: 29.239,
    y1: 40.6425,
    x2: 77.607,
    y2: 40.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1297_2294",
    x1: 31.7986,
    y1: 17.9945,
    x2: 75.1483,
    y2: 17.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1297_2294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-686.82 -205.096) scale(53.9513 28.6074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1297_2294",
    x1: 1.00366,
    y1: 23.391,
    x2: 105.842,
    y2: 23.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1297_2294",
    x1: 53.423,
    y1: 24.5749,
    x2: 53.423,
    y2: 43.2661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1297_2294",
    x1: 53.426,
    y1: 41.577,
    x2: 53.426,
    y2: 30.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1297_2294",
    x1: 53.4231,
    y1: 45.3002,
    x2: 53.4231,
    y2: 47.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1297_2294",
    x1: 43.9244,
    y1: 60.2994,
    x2: 62.9686,
    y2: 60.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1297_2294",
    x1: 43.9243,
    y1: 58.2985,
    x2: 62.9677,
    y2: 58.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1297_2294",
    x1: 53.4229,
    y1: 101.52,
    x2: 53.4229,
    y2: 87.2082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1297_2294",
    x1: 28.4028,
    y1: 72.2399,
    x2: 78.4438,
    y2: 72.2399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#74748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1297_2294",
    x1: 42.1679,
    y1: 91.016,
    x2: 66.5609,
    y2: 91.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1297_2294",
    x1: 2460.82,
    y1: 91.016,
    x2: 2485.21,
    y2: 91.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1297_2294",
    x1: 56.1637,
    y1: 87.7654,
    x2: 67.6503,
    y2: 87.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1297_2294",
    x1: 58.3477,
    y1: 87.7656,
    x2: 78.9851,
    y2: 87.7656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#1F1F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#333143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#3B384C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2F2D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractorBeam2);
export default __webpack_public_path__ + "static/media/tractorBeam2.e6b13af95cf9616558bc4233413b6e9a.svg";
export { ForwardRef as ReactComponent };